import { DwMetaDataFormPreferences } from '@devwareapps/devware-cap';

/** CAP supplies form context; Fitness owns the persistent profile content and tabs. */
export function createTeamProfilePreferences(canEdit: boolean, activitiesStarted = true, initialTab = ''): DwMetaDataFormPreferences {
    return Object.assign(new DwMetaDataFormPreferences(), {
        hidePrimaryKey: true, loadDisplayProperties: true, useButtonDefaults: false,
        contextNames: ['mdFormContext', 'challenge-context'], requiredContextNames: ['mdFormContext', 'challenge-context'],
        readOnly: true, formStyleName: 'standard',
        section: { sectionType: 'component', componentName: 'fitness-profile-content', config: { canEdit, activitiesStarted, initialTab } },
    });
}
export function updateTeamProfilePermission(preferences: DwMetaDataFormPreferences, canEdit: boolean): void {
    (preferences.section as import('@devwareapps/devware-cap').DwComponentSectionConfigPreference<{canEdit: boolean}>).config.canEdit = canEdit;
}
